import { Controller } from "@hotwired/stimulus"

// Grays out the whole table row once its suggested changes are resolved, so the
// row can stay in place (and be reversed) until the page is reloaded.
export default class extends Controller {
  static values = { resolved: Boolean }

  connect() {
    const row = this.element.parentElement
    if (!row) return

    row.classList.toggle("bg-gray-100", this.resolvedValue)
    row.classList.toggle("opacity-60", this.resolvedValue)
  }
}
